<div class="gallery-map-container">
  <app-openstreetmap
    [mapOptions]="mapOptions"
    [mapController$]="mapController"
    (mapReady)="onMapInstanceReady($event)"></app-openstreetmap>
</div>
